(function () {
  if (window.CartUpsellInit) return;
  window.CartUpsellInit = true;

  var COLOR_RE = /(farbe|colou?r)/i;
  var state = { product: null, selected: [] };

  function byId(id) { return document.getElementById(id); }

  /* ---------------- Helpers ---------------- */

  function optionNames(p) {
    if (!p || !Array.isArray(p.options)) return [];
    return p.options.map(function (o) {
      return typeof o === 'string' ? o : (o && o.name) || '';
    });
  }

  function availableVariants(p) {
    return ((p && p.variants) || []).filter(function (v) { return v.available; });
  }

  function variantOptions(v) {
    return v.options || [v.option1, v.option2, v.option3].filter(function (x) { return x != null; });
  }

  /* Werte für Option idx, gefiltert nach den bereits getroffenen Auswahlen davor */
  function valuesFor(p, idx) {
    var out = [];
    availableVariants(p).forEach(function (v) {
      var o = variantOptions(v);
      for (var i = 0; i < idx; i++) {
        if (state.selected[i] && o[i] !== state.selected[i]) return;
      }
      if (o[idx] && out.indexOf(o[idx]) === -1) out.push(o[idx]);
    });
    return out;
  }

  function imageForValue(p, idx, value) {
    var hit = availableVariants(p).find(function (v) { return variantOptions(v)[idx] === value; });
    if (hit) {
      if (hit.featured_image && hit.featured_image.src) return hit.featured_image.src;
      if (typeof hit.featured_image === 'string') return hit.featured_image;
      if (hit.featured_media && hit.featured_media.preview_image && hit.featured_media.preview_image.src) {
        return hit.featured_media.preview_image.src;
      }
    }
    return p.featured_image || '';
  }

  function currentVariant(p) {
    var names = optionNames(p);
    return availableVariants(p).find(function (v) {
      var o = variantOptions(v);
      for (var i = 0; i < names.length; i++) {
        if (!state.selected[i] || o[i] !== state.selected[i]) return false;
      }
      return true;
    }) || null;
  }

  function formatMoney(cents) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {
        style: 'currency',
        currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR'
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  function setStatus(text, isError) {
    var el = byId('CuModalStatus');
    if (!el) return;
    el.textContent = text || '';
    el.classList.toggle('cu-modal__status--error', !!isError);
  }

  /* ---------------- Rendering ---------------- */

  function renderOptions() {
    var p = state.product;
    var wrap = byId('CuModalOptions');
    if (!p || !wrap) return;

    var names = optionNames(p);
    wrap.innerHTML = '';

    names.forEach(function (name, idx) {
      var values = valuesFor(p, idx);
      if (!values.length) return;
      if (!state.selected[idx] || values.indexOf(state.selected[idx]) === -1) {
        state.selected[idx] = values[0];
      }

      var isColor = COLOR_RE.test(name);
      var group = document.createElement('div');
      group.className = 'cu-opt';

      var label = document.createElement('span');
      label.className = 'cu-opt__label';
      label.textContent = isColor ? 'Farbe' : 'Größe';
      group.appendChild(label);

      if (state.selected[idx]) {
        var valueEl = document.createElement('span');
        valueEl.className = 'cu-opt__value';
        valueEl.textContent = ' · ' + state.selected[idx];
        label.appendChild(valueEl);
      }

      var list = document.createElement('div');
      list.className = 'cu-opt__values' + (isColor ? ' cu-opt__values--color' : '');

      values.forEach(function (value) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.dataset.cuOpt = String(idx);
        btn.dataset.value = value;
        btn.setAttribute('aria-pressed', String(state.selected[idx] === value));
        btn.className = (isColor ? 'cu-swatch' : 'cu-pill') + (state.selected[idx] === value ? ' is-active' : '');

        if (isColor) {
          var src = imageForValue(p, idx, value);
          if (src) {
            var img = document.createElement('img');
            img.src = src;
            img.alt = value;
            img.loading = 'lazy';
            btn.appendChild(img);
          } else {
            var ph = document.createElement('span');
            ph.className = 'cu-swatch__ph';
            ph.textContent = value.charAt(0).toUpperCase();
            btn.appendChild(ph);
          }
          var cap = document.createElement('span');
          cap.className = 'cu-swatch__label';
          cap.textContent = value;
          btn.appendChild(cap);
        } else {
          btn.textContent = value;
        }
        list.appendChild(btn);
      });

      group.appendChild(list);
      wrap.appendChild(group);
    });

    updateSelection();
  }

  function updateSelection() {
    var p = state.product;
    var addBtn = byId('CuModalAdd');
    var priceEl = byId('CuModalPrice');
    var compareEl = byId('CuModalComparePrice');
    var badgeEl = byId('CuModalSaleBadge');
    if (!p || !addBtn) return;

    var variant = currentVariant(p);
    if (!variant) {
      setStatus('Diese Kombination ist gerade nicht verfügbar.', true);
      addBtn.disabled = true;
      return;
    }

    addBtn.dataset.variantId = String(variant.id);
    addBtn.disabled = false;
    setStatus('', false);

    var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;

    if (priceEl) {
      priceEl.textContent = formatMoney(variant.price);
      priceEl.classList.toggle('is-sale', !!onSale);
    }
    if (compareEl) {
      if (onSale) { compareEl.textContent = formatMoney(variant.compare_at_price); compareEl.hidden = false; }
      else { compareEl.hidden = true; compareEl.textContent = ''; }
    }
    if (badgeEl) {
      if (onSale) {
        var pct = Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100);
        badgeEl.textContent = '-' + pct + '%';
        badgeEl.hidden = false;
      } else {
        badgeEl.hidden = true;
        badgeEl.textContent = '';
      }
    }
  }

  /* ---------------- Sheet öffnen / schließen ---------------- */

  function closeSheet() {
    var m = byId('CuModal');
    if (m) m.hidden = true;
    state.product = null;
    state.selected = [];
    var noteEl = byId('CuSizeNote');
    if (noteEl) { noteEl.hidden = true; noteEl.textContent = ''; }
    var subEl = byId('CuModalSubtitle');
    if (subEl) { subEl.hidden = true; subEl.textContent = ''; }
    var compareEl = byId('CuModalComparePrice');
    if (compareEl) { compareEl.hidden = true; compareEl.textContent = ''; }
    var badgeEl = byId('CuModalSaleBadge');
    if (badgeEl) { badgeEl.hidden = true; badgeEl.textContent = ''; }
  }

  function openSheet(data) {
    var m = byId('CuModal');
    if (!m) return;
    state.product = null;
    state.selected = [];
    m.hidden = false;

    var titleEl = byId('CuModalTitle');
    if (titleEl) { titleEl.textContent = data.title || ''; titleEl.href = data.url || '#'; }
    var priceEl = byId('CuModalPrice');
    if (priceEl) { priceEl.textContent = ''; priceEl.classList.remove('is-sale'); }
    var compareEl = byId('CuModalComparePrice');
    if (compareEl) { compareEl.hidden = true; compareEl.textContent = ''; }
    var badgeEl = byId('CuModalSaleBadge');
    if (badgeEl) { badgeEl.hidden = true; badgeEl.textContent = ''; }
    var optWrap = byId('CuModalOptions');
    if (optWrap) optWrap.innerHTML = '';
    var addBtn = byId('CuModalAdd');
    if (addBtn) { addBtn.disabled = true; addBtn.textContent = m.dataset.cuAddLabel || 'In den Warenkorb'; }

    var subEl = byId('CuModalSubtitle');
    if (subEl) {
      if (data.subtitle) { subEl.textContent = data.subtitle; subEl.hidden = false; }
      else { subEl.hidden = true; subEl.textContent = ''; }
    }

    var noteEl = byId('CuSizeNote');
    if (noteEl) {
      if (data.sizeNote) {
        noteEl.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg><span></span>';
        noteEl.querySelector('span').textContent = data.sizeNote;
        noteEl.hidden = false;
      } else {
        noteEl.hidden = true;
        noteEl.textContent = '';
      }
    }

    setStatus('Varianten werden geladen …', false);

    fetch('/products/' + encodeURIComponent(data.handle) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('fetch'); return r.json(); })
      .then(function (product) {
        if (!availableVariants(product).length) {
          setStatus('Dieses Produkt ist aktuell ausverkauft.', true);
          return;
        }
        state.product = product;
        renderOptions();
      })
      .catch(function () {
        setStatus('Die Varianten konnten nicht geladen werden. Bitte versuche es erneut.', true);
      });
  }

  /* ---------------- In den Warenkorb ---------------- */

  function addToCart(variantId, btn, onError) {
    if (!variantId) return;
    var original = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1, properties: { _upsell: 'cart_drawer' } }],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error((res.data && res.data.description) || 'add failed');

        closeSheet();

        var drawer = document.querySelector('cart-drawer');
        var sections = res.data && res.data.sections;

        if (drawer && sections) {
          // Wie das native Mengen-Update: nur den Drawer-Inhalt (.drawer__inner)
          // ersetzen. renderContents() ruft zusätzlich open() samt Reopen-Zyklus
          // auf – das kann bei bereits offenem Drawer den Scroll-Lock (body
          // overflow-hidden) und die fixed-Position durcheinanderbringen.
          var html = sections['cart-drawer'];
          if (html) {
            try {
              var parsed = new DOMParser().parseFromString(html, 'text/html');
              var freshInner = parsed.querySelector('.drawer__inner');
              var liveInner = drawer.querySelector('.drawer__inner');
              if (freshInner && liveInner) {
                liveInner.innerHTML = freshInner.innerHTML;
              } else if (typeof drawer.renderContents === 'function') {
                drawer.renderContents(res.data);
              }
            } catch (e) {
              if (typeof drawer.renderContents === 'function') drawer.renderContents(res.data);
            }
          }

          // Cart-Icon-Bubble separat aktualisieren
          var bubbleHtml = sections['cart-icon-bubble'];
          if (bubbleHtml) {
            var bubble = document.getElementById('cart-icon-bubble');
            if (bubble) {
              try {
                var pb = new DOMParser().parseFromString(bubbleHtml, 'text/html');
                var fresh = pb.querySelector('.shopify-section') || pb.body;
                if (fresh) bubble.innerHTML = fresh.innerHTML;
              } catch (e) {}
            }
          }

          // Drawer offen halten + Scroll-Lock sicherstellen (falls er noch
          // nicht offen war, z. B. Add direkt aus einem geschlossenen Zustand)
          if (!drawer.classList.contains('active')) {
            if (typeof drawer.open === 'function') drawer.open();
          } else {
            document.body.classList.add('overflow-hidden');
          }
        }

        try { document.dispatchEvent(new CustomEvent('cart:updated')); } catch (e) {}
        try { window.dispatchEvent(new CustomEvent('sterntaler-cart-update', { detail: { source: 'cart-upsell' } })); } catch (e) {}
      })
      .catch(function (err) {
        if (btn) { btn.disabled = false; btn.textContent = original; }
        if (typeof onError === 'function') onError(err);
      });
  }

  /* ---------------- Delegierte Events ---------------- */

  function handleActivate(e) {
    var scrollBtn = e.target.closest('[data-cu-scroll]');
    if (scrollBtn) {
      var root = scrollBtn.closest('[data-cu-root]');
      var track = root && root.querySelector('[data-cu-track]');
      var card = track && track.querySelector('[data-cu-card]');
      if (track && card) {
        var step = card.getBoundingClientRect().width + 8;
        track.scrollBy({ left: step * Number(scrollBtn.dataset.cuScroll), behavior: 'smooth' });
      }
      return;
    }

    var chooseBtn = e.target.closest('[data-cu-choose]');
    if (chooseBtn) {
      e.preventDefault();
      openSheet({
        handle: chooseBtn.dataset.handle,
        title: chooseBtn.dataset.title,
        subtitle: chooseBtn.dataset.subtitle,
        url: chooseBtn.dataset.url,
        sizeNote: chooseBtn.dataset.sizeNote
      });
      return;
    }

    var quickAdd = e.target.closest('[data-cu-add]');
    if (quickAdd) {
      e.preventDefault();
      addToCart(quickAdd.dataset.variantId, quickAdd);
      return;
    }

    var closeBtn = e.target.closest('[data-cu-close]');
    if (closeBtn) {
      e.preventDefault();
      closeSheet();
      return;
    }

    var optBtn = e.target.closest('[data-cu-opt]');
    if (optBtn) {
      e.preventDefault();
      var idx = Number(optBtn.dataset.cuOpt);
      state.selected[idx] = optBtn.dataset.value;
      state.selected = state.selected.slice(0, idx + 1);
      renderOptions();
      return;
    }

    var sheetAdd = e.target.closest('#CuModalAdd');
    if (sheetAdd && !sheetAdd.disabled) {
      e.preventDefault();
      addToCart(sheetAdd.dataset.variantId, sheetAdd, function () {
        setStatus('Der Artikel konnte nicht hinzugefügt werden. Bitte versuche es erneut.', true);
      });
    }
  }

  document.addEventListener('click', handleActivate);

  // iOS-Fix: Auf iOS Safari werden click-Events von per innerHTML (Section-
  // Rendering-API, z. B. nach Add-to-Cart auf der PDP) neu eingefügten
  // Elementen nicht zuverlässig bis document delegiert. Ein zusätzlicher
  // touchend-Handler fängt echte Taps ab. Wir merken uns die Start-Position,
  // um Wischgesten (Slider scrollen) NICHT als Tap zu werten, und verhindern
  // per Flag ein doppeltes Auslösen, falls click doch noch nachfeuert.
  var cuTouch = { x: 0, y: 0, moved: false, handled: 0 };

  document.addEventListener('touchstart', function (e) {
    if (!e.target.closest('[data-cu-choose],[data-cu-add],[data-cu-close],[data-cu-opt],[data-cu-scroll],#CuModalAdd')) return;
    var t = e.touches && e.touches[0];
    if (!t) return;
    cuTouch.x = t.clientX;
    cuTouch.y = t.clientY;
    cuTouch.moved = false;
  }, { passive: true });

  document.addEventListener('touchmove', function (e) {
    var t = e.touches && e.touches[0];
    if (!t) return;
    if (Math.abs(t.clientX - cuTouch.x) > 10 || Math.abs(t.clientY - cuTouch.y) > 10) {
      cuTouch.moved = true;
    }
  }, { passive: true });

  document.addEventListener('touchend', function (e) {
    var target = e.target.closest('[data-cu-choose],[data-cu-add],[data-cu-close],[data-cu-opt],#CuModalAdd');
    if (!target || cuTouch.moved) return;
    e.preventDefault();
    cuTouch.handled = Date.now();
    handleActivate(e);
  });

  // click nach touchend unterdrücken (verhindert Doppelauslösung auf iOS)
  document.addEventListener('click', function (e) {
    if (Date.now() - cuTouch.handled < 500 &&
        e.target.closest('[data-cu-choose],[data-cu-add],[data-cu-close],[data-cu-opt],#CuModalAdd')) {
      e.stopPropagation();
      e.preventDefault();
    }
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var m = byId('CuModal');
    if (m && !m.hidden) { e.stopPropagation(); closeSheet(); }
  }, true);

  /* ----------------------------------------------------------------
     Bestellrelevanz per Shopify Recommendations API
     ------------------------------------------------------------------
     Liquid rendert bereits einen größeren Pool an Karten aus der im
     Theme-Editor hinterlegten Kollektion (Standard: die ersten
     cart_upsell_max_products davon sichtbar, Rest mit [hidden] im DOM).
     Hier wird für bis zu 3 Produkte aus dem Warenkorb Shopifys native
     "Das könnte auch gefallen"-Empfehlung abgefragt (intent=complementary)
     und mit dem Pool abgeglichen. Nur Treffer, die auch tatsächlich in der
     hinterlegten Kategorie liegen, werden nach vorne sortiert – die
     Kategorie bleibt also die Grundmenge, die API bestimmt nur die
     Reihenfolge/Auswahl daraus. Liefert die API nichts Passendes (oder
     schlägt der Request fehl), bleibt die normale Rotations-Reihenfolge
     unverändert sichtbar – rein progressive enhancement.
  ------------------------------------------------------------------- */

  function cuUniq(arr) {
    var seen = {}, out = [];
    arr.forEach(function (v) {
      if (v && !seen[v]) { seen[v] = true; out.push(v); }
    });
    return out;
  }

  function cuApplyRelevance(root) {
    if (!root || root.dataset.cuRelevanceDone === '1') return;
    root.dataset.cuRelevanceDone = '1'; // vor dem Fetch setzen: verhindert, dass unser eigenes Reordering den MutationObserver erneut auslöst

    var track = root.querySelector('[data-cu-track]');
    if (!track) return;
    var pool = Array.prototype.slice.call(track.querySelectorAll('[data-cu-card]'));
    if (pool.length < 2) return;

    var cuMax = parseInt(root.dataset.cuMax, 10);
    if (!cuMax || cuMax < 1) cuMax = pool.length;

    var cartIds = cuUniq((root.dataset.cuCartProductIds || '').split(',').map(function (s) { return s.trim(); })).slice(0, 3);
    if (!cartIds.length) return;

    Promise.all(cartIds.map(function (id) {
      return fetch('/recommendations/products.json?product_id=' + encodeURIComponent(id) + '&limit=10&intent=complementary', {
        headers: { Accept: 'application/json' }
      })
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .catch(function () { return { products: [] }; });
    }))
      .then(function (results) {
        var relevantIds = [];
        var seen = {};
        results.forEach(function (res) {
          (res.products || []).forEach(function (p) {
            var pid = String(p.id);
            if (!seen[pid]) { seen[pid] = true; relevantIds.push(pid); }
          });
        });
        if (!relevantIds.length) return;

        var byId = {};
        pool.forEach(function (card) { byId[card.dataset.productId] = card; });

        var matched = [];
        relevantIds.forEach(function (pid) {
          if (byId[pid]) matched.push(byId[pid]);
        });
        if (!matched.length) return; // keine Überschneidung mit der hinterlegten Kategorie -> nichts ändern

        var matchedSet = matched;
        var rest = pool.filter(function (card) { return matchedSet.indexOf(card) === -1; });
        var finalOrder = matched.concat(rest);

        finalOrder.forEach(function (card, i) {
          track.appendChild(card);
          card.hidden = i >= cuMax;
        });
      });
  }

  function cuInitAllRoots() {
    var roots = document.querySelectorAll('[data-cu-root]');
    for (var i = 0; i < roots.length; i++) cuApplyRelevance(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cuInitAllRoots);
  } else {
    cuInitAllRoots();
  }

  var cuDrawerEl = document.querySelector('cart-drawer');
  if (cuDrawerEl && 'MutationObserver' in window) {
    var cuObserver = new MutationObserver(function () { cuInitAllRoots(); });
    cuObserver.observe(cuDrawerEl, { childList: true, subtree: true });
  }
})();